import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import ChatBubble from './ChatBubble';

interface AgentConfig {
  name: string;
  isActive: boolean;
}

/**
 * ChatBubbleManager: decides which chat bubble to show.
 * Priority: local Gemini agent (if active) > nothing (ScriptInjector handles external scripts separately).
 * When the local agent IS active, returns the ChatBubble and also stores a flag
 * so that ScriptInjector can skip external script injection.
 */
export function ChatBubbleManager() {
  const { user } = useAuth();
  const [agentConfig, setAgentConfig] = useState<AgentConfig | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!user) {
      setChecked(true);
      return;
    }

    fetch('/api/agent-config', { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : Promise.resolve({ config: null })))
      .then((data) => {
        const cfg = data?.config;
        if (cfg && cfg.isActive) {
          setAgentConfig({ name: cfg.name ?? 'Asistente', isActive: true });
          // Signal to ScriptInjector that local agent is active so it skips external script
          (window as any).__LOCAL_AGENT_ACTIVE__ = true;
        } else {
          (window as any).__LOCAL_AGENT_ACTIVE__ = false;
        }
      })
      .catch(() => {
        (window as any).__LOCAL_AGENT_ACTIVE__ = false;
      })
      .finally(() => setChecked(true));
  }, [user]);

  if (!user || !checked || !agentConfig) return null;

  return <ChatBubble agentConfig={agentConfig} />;
}
